import React, {useEffect, useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import Simulateur89 from "../simulateur.A2.15/simulateur.A2.15";
import SimulateurA216 from "../simulateur.A2.16/simulateur.A2.16";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import SelectDepartement from "../../../components/selects/select.departement";
import Simulateur_A1_12PRO from "../simulateur.A1.12PRO/simulateur.A1.12PRO";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";

// Acquisition par la SAFER
// simulateur id 8

function Simulateur_A1_5(props) {
    const dispatch = useDispatch();

    let currUser = JSON.parse(localStorage.getItem("efluser"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [promesse, setPromesse] = useState(0)
    const [pretHypo, setPretHypo] = useState(0)
    const [sansGarantieHypo, setSansGarantieHypo] = useState(0)
    const [avecGarantieHypo, setAvecGarantieHypo] = useState(0)
    const [simu89, setSimu89] = useState(null)
    const [simuA112PRO, setSimuA112PRO] = useState(null)
    const currentIdSimu = 8
    const [simuA216, setSimuA216] = useState(null)
    const [montantAcquisition, setMontantAcquisition] = useState(0)
    const [montantPromesse, setMontantPromesse] = useState(0)
    const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
    const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
    const [dependances, setDependancesState] = useState([])
    const [dep1, setDep1] = useState({})

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    useEffect(() => {
        if (simu89 !== undefined && simu89 !== null)
            setDependances(simu89);
    }, [simu89]);

    useEffect(() => {
        if (simuA112PRO !== undefined && simuA112PRO !== null)
            setDependances(simuA112PRO);
    }, [simuA112PRO]);

    useEffect(() => {
        if (simuA216 !== undefined && simuA216 !== null)
            setDependances(simuA216);
    }, [simuA216]);

    function setDependances(simu) {
        setInRedux("dependance", simu)
    }

    function setInRedux(setter, value) {

        let object = {
            "simulateurid": currentIdSimu,
            "departementid": 0,
            "bureauid": parseInt(currUser.id),
            "inputs": {},
            "dependances": [],
        };

        if (setter === setPretHypo) {
            if (value === 0) {
                setSimuA112PRO(null)
                setSimu89(null)
                setSimuA216(null)
                setDependancesState([])
                Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
                Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
                Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
                Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
                Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
                object.dependances = []
                object.departementid = parseInt(departement)
            } else {
                Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
                Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
                Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
                Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
                Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
                object.dependances = dependances
                object.departementid = parseInt(departement)
            }
        }

        if (setter === setSansGarantieHypo) {
            if (value === 0) {
                const index = dependances.findIndex(obj => obj.simulateurid === 89);
                dependances?.splice(index, 1)
                setSimu89(null)
            }
                Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
                Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
                Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
                Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
                Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === setAvecGarantieHypo) {
            if (value === 0) {
                const index = dependances.findIndex(obj => obj.simulateurid === 90);
                dependances?.splice(index, 1)
                setSimuA216(null)
            }
                Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
                Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
                Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
                Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
                Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === "dependance") {
            if (dependances.length > 0)
                object.dependances = dependances

            if (value !== undefined) {

                let validator = false

                for (let i = 0; i < object["dependances"].length; i++) {
                    if (object['dependances'][i]?.simulateurid === value.simulateurid) {
                        object.dependances[i] = value
                        validator = true
                    }
                }

                if (validator === false) {
                    object.dependances.push(value)
                }

                setDependancesState(object.dependances)

                Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
                Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
                Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
                Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
                Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
                object.departementid = parseInt(departement)
            }
        }

        if (setter === setMontantAcquisition) {
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(value)})
            Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
            Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === setMontantPromesse) {
            Object.assign(object['inputs'], {'montant_promesse': parseInt(value)})
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
            Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === setMontantDeboursAdditionnels) {
            Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(value)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
            Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === setDepartement) {
            Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
            Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(value)
        }


        if (setter === setDeboursAdditionnels) {
            Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(value)})
            Object.assign(object['inputs'], {'promesse': parseInt(promesse)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }

        if (setter === setPromesse) {
            Object.assign(object['inputs'], {'montant_promesse': parseInt(montantPromesse)})
            Object.assign(object['inputs'], {'montant_acquisition': parseInt(montantAcquisition)})
            Object.assign(object["inputs"], {'montant_deb_add': parseInt(montantDeboursAdditionnels)})
            Object.assign(object["inputs"], {'debours_additionnels': parseInt(deboursAdditionnels)})
            Object.assign(object['inputs'], {'promesse': parseInt(value)})
            object.dependances = dependances
            object.departementid = parseInt(departement)
        }


        if (props.isParent) {
            dispatch(setSimulateurObject(object));
        } else {

        }
    }

    const depsTaxeIleFrance = [75, 77, 78, 91, 92, 93, 94, 95]
    const depsZrr = [14, 51, 71]

    const itemsTypeSale = ['Ventes d\'immeubles (régime de la copropriété) ou locaux bâtis affectés à tous usages']
    return (
        <div style={styles.container}>
            <div style={styles.card}>

                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                {props?.isParent === true && props.departements !== "" ?
                    <div style={styles.cardRow}>
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                      handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }



                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Montant de l’acquisition :
                    </div>

                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontantAcquisition}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Y a-t-il une promesse de vente reçue sous forme authentique :
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setPromesse} fieldUndefined={false}
                                     defaultValue={0}/>
                    </div>
                </div>
                {
                    parseInt(promesse) === 1 ?
                        <div style={styles.cardRow}>
                            <div style={styles.cardElemVerticalyCenter}>
                                Indiquer le montant HT des honoraires de rédaction (s'il y a lieu) :
                            </div>
                            <TextfieldNumber
                                handleChange={handleChange}
                                type={"number"}
                                placeholder={"Indiquer le montant"}
                                setter={setMontantPromesse}
                            />
                        </div>
                        :
                        <></>
                }


                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Y a-t-il des débours additionnels à prévoir ?
                        <ToolTipPerso
                            title={"Les débours sur les ventes comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."}
                        />
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2}/>
                    </div>
                </div>

                {
                    parseInt(deboursAdditionnels) === 1 ?
                        <div style={styles.cardRow}>
                            <div style={styles.cardElemVerticalyCenter}>
                                Montant des débours additionnels :
                            </div>
                            <TextfieldNumber
                                handleChange={handleChange}
                                type={"number"}
                                placeholder={"Indiquer le montant"}
                                setter={setMontantDeboursAdditionnels}
                            />
                        </div>
                        :
                        <></>
                }


                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Y'a-t-il un prêt hypothécaire ?
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setPretHypo} fieldUndefined={false}
                                     defaultValue={0}/>
                    </div>
                </div>

                {
                    parseInt(pretHypo) === 1 ?
                        <>
                            <Simulateur_A1_12PRO
                                // simulateur={props.simulateur}
                                // isParent={false}
                                // departements={departements}
                                contentDep={setDep1}
                                simulateur={props.simulateur}
                                isParent={false}
                                departementId={departement}
                                dependances={setSimuA112PRO}
                            />

                            <div style={styles.cardRow}>
                                <div style={styles.cardElemVerticalyCenter}>
                                    Y'a-t-il un cautionnement sans garantie hypothécaire ?
                                </div>
                                <div>
                                    <ButtonYesno handleChange={handleChange} setter={setSansGarantieHypo}
                                                 fieldUndefined={false}
                                                 defaultValue={0}
                                    />
                                </div>
                            </div>


                            {
                                parseInt(sansGarantieHypo) === 1 ?
                                    <>
                                        <Simulateur89
                                            simulateur={props.simulateur}
                                            isParent={false}
                                            departementId={departement}
                                            dependances={setSimu89}
                                        />
                                    </>
                                    :
                                    <></>
                            }

                            <div style={styles.cardRow}>
                                <div style={styles.cardElemVerticalyCenter}>
                                    Y'a-t-il un cautionnement avec garantie hypothécaire ?
                                </div>
                                <div>
                                    <ButtonYesno handleChange={handleChange} setter={setAvecGarantieHypo}
                                                 fieldUndefined={false}
                                                 defaultValue={0}
                                    />
                                </div>
                            </div>


                            {
                                parseInt(avecGarantieHypo) === 1 ?
                                    <>
                                        <SimulateurA216
                                            simulateur={props.simulateur}
                                            isParent={false}
                                            departementId={departement}
                                            dependances={setSimuA216}
                                        />
                                    </>
                                    :
                                    <></>
                            }

                        </>
                        :
                        <></>
                }
            </div>

        </div>
    )
}

export default Simulateur_A1_5;
